import { DevBanner, Typography } from 'app/components';
import { i18n } from 'app/utils/i18n';

import './TaxonomyHeader.scss';

interface TaxonomyHeaderProps {
  onLoadTaxonomies?: () => void;
}

export const TaxonomyHeader = ({ onLoadTaxonomies }: TaxonomyHeaderProps) => {
  return (
    <header className="taxonomy-header__wrapper">
      <Typography variant="body-8" fontWeight="semibold">
        {i18n('tag.project.tax.label')}
      </Typography>

      <div className="taxonomy-header__btns">
        <button className="custom-btn" onClick={onLoadTaxonomies}>
          {i18n('tag.load.taxonomies')}
        </button>

        <button className="custom-btn">
          {i18n('tag.import.taxonomy')}
          <DevBanner />
        </button>
      </div>
    </header>
  );
};
